<template>
  <span
    :class="$style.container"
    :style="{backgroundColor, color}"
  >
    {{ stepNumber }}
  </span>
</template>

<script>
export default {
  name: 'CircularStepNumber',

  props: {
    backgroundColor: {
      default: 'black',
      type: String,
    },
    color: {
      default: 'white',
      type: String,
    },
    stepNumber: {
      required: true,
      type: [Number, String],
    },
  },
};
</script>

<style module>
.container {
  border: 2px solid black;
  border-radius: 50%;
  display: inline-block;
  font-size: 14px;
  font-weight: 700;
  height: 28px;
  line-height: 26px;
  text-align: center;
  width: 28px;
}
</style>
